export default __webpack_public_path__ + "da9c4c08a21f172e49b54d3b433fc4eb.png";